export default "__VITE_ASSET__BlYMFsor__"